import { compact } from 'lodash';

import { mergeEmissionStats } from '@/lib/models/emissions/utils/merge-emission-stats';
import { EmissionStats } from '@/types';
import { RouteLinkSegmentApiV4Interface } from '@/types/api-types';

export const getSegmentEmissions = (segment: RouteLinkSegmentApiV4Interface): EmissionStats | undefined => {
  const { vehicles, routeType } = segment;
  const emissions = compact(
    vehicles?.map((vehicle) => {
      if (vehicle.emissions) {
        return {
          min: vehicle.emissions.wtw,
          max: vehicle.emissions.wtw,
          average: vehicle.emissions.wtw,
          unit: vehicle.emissions.unit,
          wtw: vehicle.emissions,
          mode: routeType,
        } as EmissionStats;
      }
      return undefined;
    }),
  );

  return mergeEmissionStats(emissions);
};
